<template>
  <div>
    <b-row>
      <b-col md="3">
        <input-select-search
          ref="tipoFiltro"
          v-model="filtro.tipoFiltro"
          :label="$t(`ACADEMICO.TIPO_FILTRO`)"
          :options="opcoes.tiposFiltro"
          @input="$emit('limpar')"
        />
      </b-col>
      <b-col md="3" v-if="filtro.tipoFiltro === 0">
        <input-select-search
          ref="matriculaId"
          v-model="filtro.matriculaId"
          :label="$t(`ACADEMICO.MATRICULAS`)"
          :options="opcoes.matriculas"
        />
      </b-col>
      <b-col md="3" v-if="filtro.tipoFiltro === 1">
        <input-select-search
          ref="cursoId"
          v-model="filtro.cursoId"
          :label="$t(`ACADEMICO.CURSO`)"
          :options="opcoes.cursos"
          @input="getGrupoTurmas"
        />
      </b-col>
      <b-col md="3" v-if="filtro.tipoFiltro === 1">
        <input-select-search
          ref="grupoTurmaId"
          v-model="filtro.grupoTurmaId"
          :label="$t(`ACADEMICO.GRUPO_TURMA`)"
          :options="opcoes.grupoTurmas"
          :isDisabled="desabilitar.grupoTurma"
          @input="getTurmasPorCursoGrupoTurma"
        />
      </b-col>
      <b-col md="3" v-if="filtro.tipoFiltro === 1">
        <input-select-search
          ref="turmaId"
          v-model="filtro.turmaId"
          :label="$t(`ACADEMICO.TURMA`)"
          :options="opcoes.turmas"
          :isDisabled="desabilitar.turma"
        />
      </b-col>
      <b-col md="3">
        <input-select-search
          ref="tipoContrato"
          v-model="filtro.tipoContrato"
          label="Tipo de contrato"
          :options="opcoes.tiposContrato"
        />
      </b-col>
      <b-col
        cols="12"
        md="auto"
        v-if="filtro.tipoFiltro === 1"
        class="d-flex align-items-center botao-acao-filtro"
      >
        <input-checkbox
          v-model="filtro.somentePagamentosEmDia"
          type="boolean"
          :label="$t('ACADEMICO.SOMENTE_PAGAMENTOS_EM_DIA')"
          :placeholder="$t('ACADEMICO.SOMENTE_PAGAMENTOS_EM_DIA')"
        />
      </b-col>
      <b-col cols="12" md="auto" class="botao-acao-filtro">
        <b-btn @click="filtrar" variant="primary" class="mr-2 w-100">
          {{ $t('ACADEMICO_MATRICULAS.LISTAR_CONTRATOS') }}
        </b-btn>
      </b-col>
      <b-col cols="12" md="auto" class="botao-acao-filtro mt-3">
        <b-btn @click="limparFiltro" class="mr-2 w-100">{{
          $t('GERAL.LIMPAR')
        }}</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

import MatriculaService from '@/common/services/matriculas/matriculas.service.js';

import CursoService from '@/common/services/academico/curso.service';
import TurmaService from '@/common/services/academico/turma.service';
import GrupoTurmaService from '@/common/services/grupoTurma/grupo-turma.service';

import { InputSelectSearch, InputCheckbox } from '@/components/inputs';

export default {
  name: 'filtroRematricula',
  components: {
    InputSelectSearch,
    InputCheckbox,
  },
  props: {
    filtro: { type: Object, default: () => {} }
  },
  data() {
    return {
      desabilitar: {
        turma: true,
        grupoTurma: true,
      },
      opcoes: {
        matriculas: [],
        cursos: [],
        grupoTurmas: [],
        turmas: [],
        tiposContrato: [
          {
            text: 'Todos',
            value: null,
          },
          {
            text: 'Matrícula letiva',
            value: 284,
          },
          {
            text: 'Integral',
            value: 525,
          },
        ],
        tiposFiltro: [
          {
            text: 'Por matricula',
            value: 0,
          },
          {
            text: 'Por turma',
            value: 1,
          },
        ],
      },
    };
  },
  mounted() {
    this.listarMatriculasSemPaginacao();
    this.getCursos();
    this.$emit('refs', this.$refs);
  },
  methods: {
    async listarMatriculasSemPaginacao() {
      this.$store.dispatch(START_LOADING);
      await MatriculaService.listarSemPaginacao()
        .then(({ data }) => {
          this.opcoes.matriculas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getCursos() {
      this.$store.dispatch(START_LOADING);
      this.filtro.turmaId = '';
      this.filtro.grupoTurmaId = '';
      this.filtro.cursoId = '';
      
      CursoService.listar()
        .then(({ data }) => {
          data = data.map((row) => ({
            ...data,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.cursos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getGrupoTurmas() {
      this.opcoes.turmas = [];
      this.desabilitar.turma = true;
      this.desabilitar.grupoTurma = false;
      this.filtro.turmaId = '';
      this.filtro.grupoTurmaId = '';

      this.$store.dispatch(START_LOADING);
      GrupoTurmaService.buscarGrupoTurmaPorCursoIdAnoLetivoOpcoes(
        this.filtro.cursoId,
        this.filtro.anoLetivoId
      )
        .then(data => {
          this.opcoes.grupoTurmas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getTurmasPorCursoGrupoTurma() {
      this.$store.dispatch(START_LOADING);
      this.filtro.turmaId = '';
      TurmaService.buscarPorCursoIdGrupoTurmaIdOpcoes(this.filtro)
      .then((data) => {
          this.opcoes.turmas = data;
          this.desabilitar.turma = false;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    habilitarCampo(key) {
      this.desabilitar[key] = false;
    },
    validarFiltro() {
      return helpers.validarFormulario(this.$refs);
    },
    filtrar() {
      this.$emit('filtrar');
    },
    limparFiltro() {
      this.$emit('limpar');
    },
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  gap: 15px;
}
</style>
